import { render } from "./WatchedMoviesList.vue?vue&type=template&id=4f57c309"
import script from "./WatchedMoviesList.vue?vue&type=script&lang=js"
export * from "./WatchedMoviesList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rezaradfar/Sites/vue-udemy-projects/vue-movie-rating/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__